import { useNavigate, useParams } from "react-router-dom";
import React, { useState, useEffect } from "react";
import "./styles.css";
import InputMask from "react-input-mask";

import { Button, Table, message, Tag, Spin, Card, Select, Input, List, Space, Alert, Modal } from "antd";
import {
  CheckOutlined,
  CloseOutlined,
  EditOutlined,
  EyeOutlined,
  FileExcelOutlined,
  PlusOutlined,
  SearchOutlined,
  SendOutlined,
} from "@ant-design/icons";
import { GlobalContext } from "../../../../context/globalContext";
import { GlobalContextType } from "../../../../@types/global";
import BackHeader from "../../../../components/BackHeader/BackHeader";
import api from "../../../../services/api";
import moment from "moment";
import Search from "antd/es/input/Search";
import { useAuth0 } from "@auth0/auth0-react";
import ModalEditar from "../Fornecedores/components/ModalEditar/ModalEditar";
import { Tooltip } from "antd/lib";
import Anexos from "../../../../components/Anexos/Anexos";
import { clausulasPorTipo } from "../../../../utils/clausluasPadrao";
import aditivosPorModelo from "../../../../utils/aditivosPorModelo";

interface Fornecedor {
  _id: string;
  cliente_id: string;
  nome: string;
  cnpj: string;
  telefone: string;
  email: string;
}

const EditFornecedores = () => {
  const {
    accessToken,
    windowWidth,
    pageSizeBig,
    editFornecedor,
    setEditFornecedor,
    getAnexo,
    userInfo,
    // adicionados para montar o select de área:
    moduloMapeamento,
    moduloProcessos,
  } = React.useContext(GlobalContext) as GlobalContextType;

  const { user } = useAuth0();
  const navigate = useNavigate();
  const params = useParams();

  const [formularios, setFormularios] = useState<Fornecedor[]>([]);
  const [fornecedor, setFornecedor] = useState<Fornecedor | null>(null);
  const [search, setSearch] = React.useState<string>("");
  const [showFornecedores, setShowFornecedores] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);
  const [currentAnexos, setCurrentAnexos] = useState<any[]>([]);
  const [anexos, setAnexos] = useState<any[]>([]);
  const [loadingDados, setLoadingDados] = useState<boolean>(true);
  const [loadingFormularios, setLoadingFormularios] = useState<boolean>(true);

  // --- estado da Análise de contrato ---
  const [analiseLoading, setAnaliseLoading] = useState<boolean>(true);
  const [analiseTexto, setAnaliseTexto] = useState<string>("");
  const [analiseAreaId, setAnaliseAreaId] = useState<string | undefined>(undefined);


 

 // --- NOVA ABA: ANÁLISE JURÍDICA ---
// ---------- Tipos (colocar no topo do componente, próximo aos outros types) ----------
type ClausulaTipo = keyof typeof clausulasPorTipo; // já apontará para os keys corretos
type Clausula = { id: string; titulo: string; texto: string };

// Estado para cláusulas selecionadas: para cada tipo, um array de ids de cláusula
type ClausulasSelecionadasState = Partial<Record<ClausulaTipo, string[]>>;

// ---------- States (coloque onde você define outros useState) ---------
const [tiposSelecionados, setTiposSelecionados] = useState<ClausulaTipo[]>([]);
const [clausulasSelecionadas, setClausulasSelecionadas] = useState<ClausulasSelecionadasState>({});
const [modalVisible, setModalVisible] = useState(false);
const [tipoAtivo, setTipoAtivo] = useState<ClausulaTipo | null>(null);
const [clausulaAtiva, setClausulaAtiva] = useState<string | null>(null);


type AditivoKey = keyof typeof aditivosPorModelo;
const [modalAditivo, setModalAditivo] = useState(false);
const [aditivosSelecionados, setAditivosSelecionados] = useState<AditivoKey[]>([]);
const [aditivoAtivo, setAditivoAtivo] = useState<AditivoKey | null>(null);

// mapeamento das chaves para labels amigáveis (em português correto)
const tipoLabelMap: Record<string, string> = {
  recursos_humanos: "Recursos Humanos",
  prestacao_servicos: "Prestação de Serviços",
  hipoteses_gerais: "Hipóteses Gerais",
  planos_saude: "Planos de Saúde",
  clausulas_especificas: "Causas Específicas",
  orientacoes_dpo: "Orientações DPO",
};

// helper para obter label (fallback para 'beautify' caso não tenha no map)
const getTipoLabel = (tipoKey?: string) => {
  if (!tipoKey) return "";
  if (tipoLabelMap[tipoKey]) return tipoLabelMap[tipoKey];
  // fallback: transforma snake_case em Title Case (caso tenha chaves novas)
  return tipoKey
    .replace(/_/g, " ")
    .replace(/\b\w/g, (l) => l.toUpperCase());
};




useEffect(() => {
  const fetchAnaliseJuridica = async () => {
    if (!params.fornecedorid) return;
    try {
      const { data } = await api.get(`/fornecedor/analise-juridica/${params.fornecedorid}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          User: user?.sub,
        },
      });

      const analise = data?.analise_juridica;
      if (analise) {
        setTiposSelecionados(analise.tipos_selecionados || []);
        setClausulasSelecionadas(
          (analise.clausulas_selecionadas || []).reduce(
            (acc: Record<string, string[]>, item: any) => {
              acc[item.tipo] = item.clausulas?.map((c: any) => c.id) || [];
              return acc;
            },
            {}
          )
        );
        setAditivosSelecionados(
  (analise.aditivos_selecionados || []).map((a: any) => a.id)
); // ✅ nome correto conforme backend
      }
    } catch (err) {
      console.error("[GET /fornecedor/analise-juridica] Erro ao buscar:", err);
    }
  };

  fetchAnaliseJuridica();
}, [params.fornecedorid, accessToken, user?.sub]);




  useEffect(() => {
  console.log("[v0 DEBUG] useEffect executado, editFornecedor:", editFornecedor);
  
  if (editFornecedor) {
    console.log("[v0 DEBUG] Chamando getAnexo para fornecedor ID:", editFornecedor._id);
    setLoading(true);
    getAnexo(editFornecedor._id)
      .then((res) => {
        console.log("[v0 DEBUG] getAnexo retornou:", res);
        console.log("[v0 DEBUG] Tipo de res:", typeof res);
        console.log("[v0 DEBUG] É array?:", Array.isArray(res));
        console.log("[v0 DEBUG] Quantidade de anexos:", res?.length);
        setAnexos(res);
      })
      .catch((err) => {
        console.error("[v0 DEBUG] Erro no getAnexo:", err);
        console.error("[v0 DEBUG] err.response:", err.response);
      })
      .finally(() => {
        setLoading(false);
      });
  } else {
    console.log("[v0 DEBUG] editFornecedor é null/undefined, não chamando getAnexo");
  }
}, [editFornecedor, params.fornecedorid]);

  useEffect(() => {
    if (fornecedor) {
      setEditFornecedor(fornecedor);
    }
  }, [fornecedor]);

  const fetchFormularios = async () => {
    try {
      if (!formularios?.[0]) {
        await api
          .get(`/formularios/${params.fornecedorid}`, {
            headers: {
              Authorization: `Bearer ${accessToken}`,
              User: user?.sub,
            },
          })
          .then((res) => setFormularios(res.data))
          .finally(() => setLoadingFormularios(false));
      }
    } catch (error) {
      console.error("Error fetching formularios:", error);
    }
  };



  const fetchData = async () => {
    if (accessToken && user && !fornecedor) {
      try {
        await api
          .get(`/fornecedoresmodel/${params.fornecedorid}`, {
            headers: {
              Authorization: `Bearer ${accessToken}`,
              User: user?.sub,
            },
          })
          .then((res) => setFornecedor(res.data))
          .finally(() => setLoadingDados(false));
      } catch (error) {
        console.error("Error fetching fornecedores:", error);
      }
    }
  };

  // buscar análise já existente
  const fetchAnaliseContrato = async () => {
    if (!params.fornecedorid) return;
    setAnaliseLoading(true);
    try {
      const { data } = await api.get(`/fornecedor/analise/${params.fornecedorid}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          User: user?.sub,
        },
      });
      if (data) {
        setAnaliseTexto(data.texto || "");
        setAnaliseAreaId(data.area_id || undefined);
      }
    } catch (err) {
      // se ainda não existir, mantém vazio sem erro
    } finally {
      setAnaliseLoading(false);
    }
  };

  // salvar análise
 const salvarAnaliseContrato = async () => {
  if (!params.fornecedorid) return;
  try {
    setAnaliseLoading(true);
    await api.patch(
      `/fornecedor/analise/${params.fornecedorid}`,
      { texto: analiseTexto, area_id: analiseAreaId || null },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          User: user?.sub,
        },
      }
    );
    message.success("Análise salva!");
  } catch (err: any) {
    if (err.response?.status === 404) {
      // se não existe ainda, cria
      try {
        await api.post(
          `/fornecedor/analise/${params.fornecedorid}`,
          { texto: analiseTexto, area_id: analiseAreaId || null },
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
              User: user?.sub,
            },
          }
        );
        message.success("Análise criada!");
      } catch {
        message.error("Erro ao criar análise.");
      }
    } else {
      message.error("Erro ao salvar análise.");
    }
  } finally {
    setAnaliseLoading(false);
  }
};

  const showAddFornecedor = () => {
    showFornecedores ? setShowFornecedores(false) : setShowFornecedores(true);
  };

  const columnsFornecedor: any = [
    { title: "Razão social", dataIndex: "nome", key: "nome" },
    {
      title: "Nome do responsável",
      dataIndex: "representante",
      key: "representante",
    },
    {
      title: "CNPJ",
      dataIndex: "cnpj",
      key: "cnpj",
    },
    { title: "Email", dataIndex: "email", key: "email" },
    {
      title: "Telefone",
      dataIndex: "telefone",
      key: "telefone",
      render: (tel: string) =>
        tel ? (
          <InputMask
            type="text"
            mask={
              tel
                .replaceAll(" ", "")
                .replaceAll("(", "")
                .replaceAll(")", "")
                .replaceAll("-", "").length === 10
                ? "(99) 9999-9999"
                : tel
                    .replaceAll(" ", "")
                    .replaceAll("(", "")
                    .replaceAll(")", "")
                    .replaceAll("-", "").length === 11
                ? "(99) 9 9999-9999"
                : tel
                    .replaceAll(" ", "")
                    .replaceAll("(", "")
                    .replaceAll(")", "")
                    .replaceAll("-", "").length === 9
                ? "9 9999-9999"
                : "9999-9999"
            }
            value={tel}
            defaultValue={tel}
            disabled
          >
            <input className="input_dis_text" style={{ width: "9rem" }} />
          </InputMask>
        ) : (
          <p style={{ textAlign: "center", opacity: 0.3 }}>-</p>
        ),
    },
    {
      title: "Último envio",
      dataIndex: "envio",
      key: "envio",
      render: (envio: any) =>
        envio?.user_name ? (
          <>
            {moment(new Date(envio.created_at)).format("DD/MM/YYYY")} por
            <Tooltip title={envio.user_name}>
              <Button style={{ marginLeft: "-0.7rem" }} type="link">
                {envio.user_name.length > 10
                  ? envio.user_name.slice(0, 10) + "..."
                  : envio.user_name}
              </Button>
            </Tooltip>
          </>
        ) : (
          <p style={{ fontSize: "0.6rem", opacity: 0.3, fontWeight: "300" }}>
            Sem informações
          </p>
        ),
    },
    {
      title: "Status",
      dataIndex: "status_acao",
      key: "status_acao",
      render: (status: string) => {
        let icon;
        let color;
        let text;
        if (status === "continuarcontrato") {
          icon = <EditOutlined />;
          color = "#fcba03";
          text = "Aditar contrato";
        } else if (status === "continuar") {
          icon = <CheckOutlined />;
          color = "green";
          text = "Continuar contrato";
        } else if (status === "descontinuar") {
          icon = <CloseOutlined />;
          color = "red";
          text = "Descontinuar contrato";
        }

        return (
          <span style={{ color: color }}>
            {icon} {text}
          </span>
        );
      },
    },
  ];

  // Fetch fornecedores and update the state
  useEffect(() => {
    if (userInfo?._id) {
      fetchFormularios();
      fetchData();
      fetchAnaliseContrato();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo]);

  const sendEmailToFornecedor = async (record: any) => {
    try {
      if (fornecedor) {
        const requestData = {
          client_id: record.cliente_id,
          fornecedores: [
            {
              fornecedor_id: fornecedor._id,
              email: fornecedor.email,
              questionario_id: record._id,
            },
          ],
        };

        await api
          .post("/enviarEmailsFornecedor", requestData)
          .then((res: any) => {
            console.log(res.data);
            message.success("Questionário enviado com sucesso!");
          });
      }
    } catch (error) {
      message.error("Erro ao enviar questionário para o fornecedor!");
    }
    fetchFormularios();
    fetchData();
  };

  const novoQuestionario = async () => {
    try {
      if (fornecedor) {
        const requestData = {
          client_id: params.id,
          fornecedores: [
            {
              fornecedor_id: fornecedor._id,
              email: fornecedor.email,
            },
          ],
        };

        message.loading("Criando questionário...");
        await api.post("/criarQuestionario", requestData).finally(() => {
          fetchFormularios();
          message.success("Questionário criado com sucesso!");
        });
      }
    } catch (error) {
      message.error("Erro ao criar questionário para o fornecedor!");
    }
  };

  const columns = [
    {
      title: "ID",
      dataIndex: "_id",
      key: "_id",
      render: (id: any, record: any, index: number) =>
        `Questionário ${
          formularios
            .sort(
              (a: any, b: any) =>
                new Date(a.created_at).getTime() -
                new Date(b.created_at).getTime()
            )
            .indexOf(record) + 1
        }`,
    },
    {
      title: "Criação do questionário",
      dataIndex: "created_at",
      key: "created_at",
      render: (date: any) => moment(new Date(date)).format("DD/MM/YYYY"),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status: string, record: any) => {
        let iconColor = "";
        let text = "";
        if (!status) {
          iconColor = "#b5b5b5";
        } else if (status === "respondido") {
          iconColor = "green";
        } else if (status === "enviado") {
          iconColor = "#fcba03";
        }

        if (!status) {
          text = "Não Enviado";
        } else if (status === "respondido") {
          text = "Questionário respondido";
        } else if (status === "enviado") {
          text = "Enviado";
        }

        return (
          <>
            <Tag color={iconColor} style={{ fontWeight: "bold" }}>
              {text}
            </Tag>
            {text === "Questionário respondido" && (
              <span>
                em {moment(new Date(record.updated_at)).format("DD/MM/YYYY")}
              </span>
            )}
            {text === "Enviado" && (
              <span>
                em {moment(new Date(record.updated_at)).format("DD/MM/YYYY")}
              </span>
            )}
          </>
        );
      },
    },
    {
      title: "Ações",
      dataIndex: "_id",
      key: "_id",
      render: (id: String, record: any) => (
        <div>
          {record.status !== "respondido" && (
            <Button
              type="primary"
              onClick={() => sendEmailToFornecedor(record)}
              icon={<SendOutlined />}
              style={{ marginRight: "1rem" }}
            >
              {record.status === "enviado" ? "Enviar novamente" : "Enviar"}
            </Button>
          )}
          {(record.status === "respondido" ||
            userInfo?.grupos?.find(
              (gp: any) => gp.name === "seusdados" || gp.name === "assinante"
            )) && (
            <>
              <Button
                type="default"
                className="btn-success"
                htmlType="submit"
                icon={<EyeOutlined />}
                onClick={() => {
                  navigate(
                    `/analisefornecedor/${params.id}/${params.fornecedorid}/${id}`
                  );
                }}
              >
                Análise
              </Button>
            </>
          )}
        </div>
      ),
    },
  ];

  const columnsMobile = [
    {
      title: "ID",
      dataIndex: "_id",
      key: "_id",
      render: (id: any, record: any, index: number) =>
        `${
          formularios
            .sort(
              (a: any, b: any) =>
                new Date(a.created_at).getTime() -
                new Date(b.created_at).getTime()
            )
            .indexOf(record) + 1
        }`,
    },
    {
      title: "Data",
      dataIndex: "created_at",
      key: "created_at",
      render: (date: any) => moment(new Date(date)).format("DD/MM/YYYY"),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status: string) => {
        let iconColor = "";
        let text = "";
        if (!status) {
          iconColor = "#b5b5b5";
        } else if (status === "respondido") {
          iconColor = "green";
        } else if (status === "enviado") {
          iconColor = "#fcba03";
        }

        if (!status) {
          text = "N/ Enviado";
        } else if (status === "respondido") {
          text = "Respondido";
        } else if (status === "enviado") {
          text = "Enviado";
        }

        return (
          <Tag color={iconColor} style={{ fontWeight: "bold" }}>
            {text}
          </Tag>
        );
      },
    },
    {
      title: "Ações",
      dataIndex: "_id",
      key: "_id",
      render: (id: String, record: any) => (
        <div>
          {record.status !== "respondido" && (
            <Button
              type="primary"
              onClick={() => sendEmailToFornecedor(record)}
              icon={<SendOutlined />}
              style={{ marginRight: "1rem" }}
            >
              {record.status === "enviado" ? "Enviar novamente" : "Enviar"}
            </Button>
          )}
          {record.status === "respondido" && (
            <>
              <Button
                type="default"
                className="btn-success"
                htmlType="submit"
                icon={<EyeOutlined />}
                onClick={() => {
                  navigate(
                    `/analisefornecedor/${params.id}/${params.fornecedorid}/${id}`
                  );
                }}
              >
                Análise
              </Button>
            </>
          )}
        </div>
      ),
    },
  ];

  const onSearch = (value: string) => setSearch(value);

  // options de área (mesma lógica da ModalEditar)
  const areasOptions =
    moduloMapeamento?.currentMapeamento?.areas
      ?.map((a: string) => moduloProcessos?.areas?.find((area: any) => area._id === a))
      ?.filter((a: any) => a?._id && a?.description)
      ?.map((a: any) => ({ value: a._id, label: a.description })) || [];

  const handleDownloadCSV = async () => {
    try {
      const response = await api.get(
        `/download-csv/fornecedor/${params.fornecedorid}`,
        {
          responseType: "blob",
        }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "fornecedor_questionarios.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      message.error("Erro ao gerar CSV");
    }
  };

  return (
    <div className="Fornecedores">
      <BackHeader
        title={"Questionários " + (fornecedor?.nome || "")}
        route={`/clientesFornecedor/fornecedor/${params.id}`}
      />
      <br />
      <h3>Dados do fornecedor</h3>
      <br />
      <Table
        loading={loadingDados}
        size="small"
        dataSource={fornecedor ? [fornecedor] : []}
        columns={columnsFornecedor}
        pagination={false}
      />

      {/* ---- NOVA SEÇÃO: ANÁLISE DE CONTRATO ---- */}
<br />
<Card title="Análise de contrato">
  <Space direction="vertical" size="large" style={{ width: "100%" }}>
    <div>
      <div style={{ fontWeight: 600, marginBottom: 8 }}>Contrato(s) anexado(s)</div>
      {loading ? (
        <Spin tip="Carregando" size="small">
          <div className="content" />
        </Spin>
      ) : anexos?.length ? (
        <List
          dataSource={anexos}
          renderItem={(f: any) => (
            <List.Item>
              <a href={f.url} target="_blank" rel="noreferrer">
                {f.name || "Arquivo"}
              </a>
            </List.Item>
          )}
        />
      ) : (
        <Alert type="info" message="Nenhum contrato encontrado para este fornecedor." />
      )}
    </div>

    <div>
      <div style={{ fontWeight: 600, marginBottom: 8 }}>Área responsável pela análise</div>
      {areasOptions?.length ? (
        <Select
          allowClear
          style={{ width: 420, maxWidth: "100%" }}
          placeholder="Selecione uma área"
          options={areasOptions}
          value={analiseAreaId}
          onChange={setAnaliseAreaId}
          showSearch
          filterOption={(input, option) =>
            ((option?.label as string) || "").toLowerCase().includes(input.toLowerCase())
          }
          disabled={userInfo?.grupos?.some((g: any) => g.name === "assinante")}
        />
      ) : (
        <Alert type="warning" showIcon message="Cliente sem áreas mapeadas." />
      )}
    </div>

    <div>
      <div style={{ fontWeight: 600, marginBottom: 8 }}>Análise de contrato</div>
      <Input.TextArea
        rows={6}
        maxLength={5000}
        value={analiseTexto}
        onChange={(e) => setAnaliseTexto(e.target.value)}
        placeholder="Escreva aqui a orientação jurídica/observações sobre o contrato..."
        disabled={userInfo?.grupos?.some((g: any) => g.name === "assinante")}
      />
    </div>

    {!userInfo?.grupos?.some((g: any) => g.name === "assinante") && (
      <div>
        <Button type="primary" onClick={salvarAnaliseContrato} loading={analiseLoading}>
          Salvar análise
        </Button>
      </div>
    )}
  </Space>
</Card>
{/* ---- FIM DA SEÇÃO ---- */}


   {/* ---- NOVA ABA: ANÁLISE JURÍDICA ---- */}
<br />
<Card title="Análise Jurídica">
  <Space direction="vertical" size="large" style={{ width: "100%" }}>
    {/* Tipos de Cláusulas */}
    <div>
      <div style={{ fontWeight: 600, marginBottom: 8 }}>Tipos de Cláusulas</div>
      <Select
        mode="multiple"
        style={{
          width: "100%",
          maxWidth: 600,
          cursor: "pointer",
        }}
        placeholder="Selecione os tipos de cláusulas"
        options={Object.keys(clausulasPorTipo).map((tipo) => ({
          label: getTipoLabel(tipo),
          value: tipo,
        }))}
        value={tiposSelecionados}
        onChange={(vals) => setTiposSelecionados(vals as ClausulaTipo[])}
        disabled={userInfo?.grupos?.some((g: any) => g.name === "assinante")}
        maxTagCount="responsive"
      />
    </div>

    {/* Renderização das Cláusulas */}
    <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
      {tiposSelecionados.map((tipo) => (
        <div
          key={tipo}
          style={{
            border: "1px solid #eee",
            borderRadius: 8,
            padding: 16,
            background: "#fafafa",
            display: "flex",
            flexDirection: "column",
            gap: 8,
            overflow: "hidden",
          }}
        >
          <div style={{ fontWeight: 600 }}>
            {getTipoLabel(tipo)}
          </div>

          <Select
            mode="multiple"
            style={{
              width: "100%",
              maxWidth: 600,
              cursor: "pointer",
            }}
            placeholder="Selecione uma ou mais cláusulas"
            options={clausulasPorTipo[tipo as keyof typeof clausulasPorTipo].map(
              (cl) => ({
                label: cl.titulo,
                value: cl.id,
              })
            )}
            value={clausulasSelecionadas[tipo] || []}
            onChange={(val) =>
              setClausulasSelecionadas((prev) => ({
                ...prev,
                [tipo]: val as string[],
              }))
            }
            disabled={userInfo?.grupos?.some(
              (g: any) => g.name === "assinante"
            )}
            maxTagCount={5}
            dropdownRender={(menu) => (
              <div style={{ maxHeight: 300, overflowY: "auto" }}>{menu}</div>
            )}
          />

          {/* Botões “Ver Cláusula” */}
          {Array.isArray(clausulasSelecionadas[tipo]) &&
            clausulasSelecionadas[tipo]!.length > 0 && (
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 8,
                  marginTop: 8,
                  maxHeight: 180,
                  overflowY: "auto",
                  paddingRight: 4,
                }}
              >
                {clausulasSelecionadas[tipo]!.map((id) => (
                  <Button
                    key={id}
                    icon={<EyeOutlined />}
                    onClick={() => {
                      setTipoAtivo(tipo);
                      setModalVisible(true);
                      setClausulaAtiva(id);
                    }}
                    style={{
                      background: "#fff",
                      flex: "0 0 auto",
                      cursor: "pointer",
                    }}
                  >
                    {
                      clausulasPorTipo[tipo as keyof typeof clausulasPorTipo]
                        .find((c) => c.id === id)?.titulo || id
                    }
                  </Button>
                ))}
              </div>
            )}
        </div>
      ))}
    </div>

    {/* ---- BLOCO DE ADITIVOS (movido para o final) ---- */}
    <div>
      <div style={{ fontWeight: 600, marginTop: 24, marginBottom: 8 }}>
        Aditivos
      </div>
      <Select
        mode="multiple"
        style={{
          width: "100%",
          maxWidth: 600,
          cursor: "pointer",
        }}
        placeholder="Selecione um ou mais modelos de aditivo"
        options={Object.keys(aditivosPorModelo).map((key) => ({
          label: aditivosPorModelo[key].titulo,
          value: key,
        }))}
        value={aditivosSelecionados}
        onChange={(vals) => setAditivosSelecionados(vals as string[])}
        disabled={userInfo?.grupos?.some((g: any) => g.name === "assinante")}
        maxTagCount="responsive"
      />

      {Array.isArray(aditivosSelecionados) && aditivosSelecionados.length > 0 && (
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: 8,
            marginTop: 8,
            maxHeight: 180,
            overflowY: "auto",
            paddingRight: 4,
          }}
        >
          {aditivosSelecionados.map((id) => (
            <Button
              key={id}
              icon={<EyeOutlined />}
              onClick={() => {
                setAditivoAtivo(id);
                setModalAditivo(true);
              }}
              style={{
                background: "#fff",
                flex: "0 0 auto",
                cursor: "pointer",
              }}
            >
              {aditivosPorModelo[id]?.titulo || id}
            </Button>
          ))}
        </div>
      )}
    </div>

    {/* ---- FIM DO BLOCO DE ADITIVOS ---- */}

    {/* Botão SALVAR */}
    {!userInfo?.grupos?.some((g: any) => g.name === "assinante") && (
      <div style={{ marginTop: 24 }}>
        <Button
          type="primary"
          onClick={async () => {
            if (!params.fornecedorid) return;
            try {
              const clausulasPayload = tiposSelecionados.map((tipo) => {
                const ids = clausulasSelecionadas[tipo] || [];
                const clausulasFull: Clausula[] = ids
                  .map((id) => {
                    const found = clausulasPorTipo[
                      tipo as keyof typeof clausulasPorTipo
                    ].find((c) => c.id === id);
                    return found
                      ? { id: found.id, titulo: found.titulo, texto: found.texto }
                      : null;
                  })
                  .filter(Boolean) as Clausula[];

                return { tipo, clausulas: clausulasFull };
              });

              const payload = {
                tipos_selecionados: tiposSelecionados,
                clausulas_selecionadas: clausulasPayload,
                aditivos_selecionados: aditivosSelecionados.map(
                  (id) => aditivosPorModelo[id]
                ),
                salvo_por: userInfo?.name || user?.name || "Usuário",
              };

              await api.patch(
                `/fornecedor/analise-juridica/${params.fornecedorid}`,
                payload,
                {
                  headers: {
                    Authorization: `Bearer ${accessToken}`,
                    User: user?.sub,
                  },
                }
              );

              message.success("Análise jurídica salva com sucesso!");
              setFornecedor((prev) => ({
                ...prev!,
                analise_juridica: payload,
              }));
              setTiposSelecionados(payload.tipos_selecionados);
              setClausulasSelecionadas(
                payload.clausulas_selecionadas.reduce(
                  (acc: Record<string, string[]>, item: any) => {
                    acc[item.tipo] =
                      item.clausulas?.map((c: any) => c.id) || [];
                    return acc;
                  },
                  {}
                )
              );
              setAditivosSelecionados(
                payload.aditivos_selecionados.map((a: any) => a.id)
              );
            } catch (err) {
              console.error("Erro salvando análise:", err);
              message.error("Erro ao salvar análise.");
            }
          }}
        >
          Salvar Seleção
        </Button>
      </div>
    )}
  </Space>

  {/* Modal de Cláusulas */}
  <Modal
    open={modalVisible}
    onCancel={() => setModalVisible(false)}
    title={tipoAtivo ? `Cláusula - ${getTipoLabel(tipoAtivo)}` : "Cláusula"}
    width="80vw"
    footer={[
      <Button key="close" onClick={() => setModalVisible(false)}>
        Fechar
      </Button>,
    ]}
  >
    {tipoAtivo && clausulaAtiva ? (
      <p style={{ whiteSpace: "pre-wrap", fontSize: "1rem" }}>
        {
          clausulasPorTipo[tipoAtivo as keyof typeof clausulasPorTipo].find(
            (c) => c.id === clausulaAtiva
          )?.texto
        }
      </p>
    ) : (
      <Alert message="Selecione uma cláusula para visualizar." type="info" />
    )}
  </Modal>

  {/* Modal de Aditivos */}
  <Modal
    open={modalAditivo}
    onCancel={() => setModalAditivo(false)}
    title={aditivoAtivo ? aditivosPorModelo[aditivoAtivo]?.titulo : "Aditivo"}
    width="80vw"
    footer={[
      <Button key="close" onClick={() => setModalAditivo(false)}>
        Fechar
      </Button>,
    ]}
  >
    {aditivoAtivo ? (
      <p style={{ whiteSpace: "pre-wrap", fontSize: "1rem" }}>
        {aditivosPorModelo[aditivoAtivo]?.texto}
      </p>
    ) : (
      <Alert message="Selecione um aditivo para visualizar." type="info" />
    )}
  </Modal>
</Card>
{/* ---- FIM DA NOVA ABA ---- */}




      <br />
      <div>
        <Button
          onClick={() => {
            setEditFornecedor(fornecedor);
            showAddFornecedor();
          }}
          icon={<EditOutlined />}
        >
          Editar
        </Button>
        {userInfo?.grupos?.find(
          (gp: any) => gp.name === "assinante" || gp.name === "seusdados"
        ) && (
          <Button
            style={{
              marginBottom: "2rem",
              marginLeft: "2rem",
              backgroundColor: "green",
            }}
            type="primary"
            icon={<FileExcelOutlined />}
            onClick={handleDownloadCSV}
          >
            Baixar CSV
          </Button>
        )}
      </div>

      <br />
      <br />
      <br />
      <h3>Evidências</h3>
      <br />
      {loading ? (
        <Spin tip="Carregando" size="small">
          <div className="content" />
        </Spin>
      ) : anexos[0] ? (
        <Anexos
          currentAnexos={[...currentAnexos, ...anexos]}
          onChange={(v) =>
            setCurrentAnexos(v.fileList.map((f: any) => f.originFileObj))
          }
          setCurrentAnexos={setCurrentAnexos}
          showUpload={false}
        />
      ) : (
        <p
          style={{
            opacity: 0.4,
            fontSize: "0.8rem",
          }}
        >
          Nenhum anexo adicionado
        </p>
      )}
      <br />
      <br />
      <h3>Questionários aplicados</h3>

      <br />
      <div className="clientes__actions">
        <Search
          placeholder="Buscar questionário"
          className="clientes__actions--search"
          allowClear
          enterButton={<SearchOutlined />}
          onSearch={onSearch}
        />
        <div>
          <Button
            className="clientes__actions--new"
            type="primary"
            onClick={() => novoQuestionario()}
            icon={<PlusOutlined />}
            style={{ marginLeft: "1rem" }}
          >
            Aplicar questionário
          </Button>
        </div>
      </div>
      <Table
        loading={loadingFormularios}
        size="small"
        dataSource={formularios
          .sort(
            (a: any, b: any) =>
              new Date(b.created_at).getTime() -
              new Date(a.created_at).getTime()
          )
          .filter(
            (form: any, index: number) =>
              form._id.toString().toUpperCase() === search.toUpperCase() ||
              !search
          )}
        columns={windowWidth > 800 ? columns : columnsMobile}
        pagination={{ pageSize: pageSizeBig + 2 }}
        scroll={{ x: 0 }}
      />
      {params.id && (
        <ModalEditar
          editFornecedor={editFornecedor}
          showFornecedores={showFornecedores}
          showAddFornecedor={showAddFornecedor}
          clientId={params.id}
        />
      )}
    </div>
  );
};

export default EditFornecedores;
